import { render, staticRenderFns } from "./WardrobeDoorsDivision.vue?vue&type=template&id=f6f6505a&"
import script from "./WardrobeDoorsDivision.vue?vue&type=script&lang=js&"
export * from "./WardrobeDoorsDivision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports